import clsx from "clsx";
import type { ComponentPropsWithoutRef, ElementType } from "react";

export type ButtonProps<C extends ElementType> = {
  as?: C;
  disabled?: boolean;
} & ComponentPropsWithoutRef<C | "button">;

const Button = <C extends ElementType>({
  children,
  className,
  disabled = false,
  as,
  ...props
}: ButtonProps<C>) => {
  const Component = as || "button";

  return (
    <Component
      {...props}
      className={clsx(
        "rounded-lg py-2 text-center bg-foreground font-semibold text-white",
        disabled ? "cursor-not-allowed bg-foreground-lighter" : "bg-primary",
        className,
      )}
      disabled={disabled}
    >
      {children}
    </Component>
  );
};

export default Button;
